module.exports = __webpack_public_path__ + "static/media/UserDiscount2.4ec0a323.svg";